import { SvgIcon, SvgIconProps } from '@mui/material'

export const AudioMessageIcon = ({ sx, ...props }: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 16 16"
    sx={{ width: '16px', height: '16px', color: 'gray', ...sx }}
    {...props}
  >
    <path
      d="M13.33 8.79V7.33a5.33 5.33 0 1 0-10.66 0V8.8a2 2 0 0 0-1.34 1.88V12a2 2 0 0 0 2 2h2a.67.67 0 0 0 .67-.67v-4a.67.67 0 0 0-.67-.66H4V7.33a4 4 0 0 1 8 0v1.34h-1.33a.67.67 0 0 0-.67.66v4a.67.67 0 0 0 .67.67h2a2 2 0 0 0 2-2v-1.33a2 2 0 0 0-1.34-1.88ZM4.67 10v2.67H3.33a.67.67 0 0 1-.66-.67v-1.33a.67.67 0 0 1 .66-.67h1.34Zm8.66 2a.67.67 0 0 1-.66.67h-1.34V10h1.34a.67.67 0 0 1 .66.67V12Z"
      fill="#818181"
    />
  </SvgIcon>
)
